import ChangelogsComponent from './Changelogs';

export const Changelogs = ChangelogsComponent;
